<template>
    <div class="r-auth-register-company container">
        <h2>Create account</h2>
        <div class="row justify-content-center">
            <form
                class="col-lg-12"
                @submit.prevent="handleSubmit"
            >
                <h4 class="mt-4 mb-4">Register Association Representative</h4>
                <base-select
                    name="sectorAssociationName"
                    label="Field of activity"
                    v-validate="'required'"
                    :value="sectorAssociationName"
                    @input="handleSectorAssociationNameChange"
                    :options="sectorAssociationNameOptions"
                    :err="errors.collect('sectorAssociationName')"
                />
                <div class="">
                    <div class="base-control base-checkbox form-group">
                        <input name="internalSource" id="internal-source" class="styled-checkbox" type="checkbox" checked disabled>
                        <label id="internal-source-label" style="font-weight: normal;" class="mb-0" for="internal-source">Internal pre-consumer waste recycled</label>
                    </div>
                    <div class="base-control base-checkbox form-group">
                        <input
                            name="externalSource"
                            id="external-source"
                            class="styled-checkbox"
                            type="checkbox"
                            :checked="externalSource"
                            @change="handleExternalSourceChange"
                        >
                        <label style="font-weight: normal;" class="mb-0" for="external-source">Volume of recyclate brought from an external source</label>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-6 text-left">
                        <base-button
                            radius="bl"
                            component-class="blue"
                            @click.native="$router.push({ name: 'auth-register' })"
                        ><i class="fas fa-arrow-left mr-3"></i> Previous
                        </base-button>
                    </div>
                    <div class="col-6 text-right">
                        <base-button
                            radius="br"
                            component-class="green filled"
                            type="submit"
                        > Register <i class="fas fa-arrow-right ml-3"></i>
                        </base-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import BaseButton from '@/components/inputs/button/BaseButton';
    import BaseSelect from '@/components/inputs/select/BaseSelect';
    import getFormErrors from '@/helpers/errors';
    import constances from '@/configs/constances';

    export default {
        data() {
            return {
                sectorAssociationNameOptions: [
                    { value: constances.sectorAssociation.PIPES.id, label: 'Pipes' },
                    { value: constances.sectorAssociation.FLOORING.id, label: 'Flooring' },
                    { value: constances.sectorAssociation.ROOFING_OR_WATERPROOFING.id, label: 'Roofing/waterproofing' },
                    { value: constances.sectorAssociation.PROFILES.id, label: 'Profiles' },
                    { value: constances.sectorAssociation.CABLES.id, label: 'Cables' },
                    { value: constances.sectorAssociation.FILMS_AND_SHEETS.id, label: 'Films & Sheets' },
                ],
                formErrors: {
                    sectorAssociationName: [],
                },
            };
        },

        computed: {
            ...mapState({
                authData: state => state.auth ? state.auth.data : {},
                sectorAssociationName: state => state.auth.sectorAssociationName,
                externalSource: state => state.auth.externalSource,
            }),
        },

        methods: {
            handleSectorAssociationNameChange(event) {
                this.$store.commit('auth/setStoreValue', { key: 'sectorAssociationName', value: event });
            },
            handleExternalSourceChange() {
                this.$store.commit('auth/setStoreValue', { key: 'externalSource', value: !this.externalSource });
            },
            async handleSubmit() {
                const isFormValid = await this.$validator.validateAll();
                this.formErrors = await getFormErrors(this.$validator, this.formErrors);
                if (isFormValid) {
                    const { role, name, email, password } = this.authData;
                    const { sectorAssociationName, externalSource } = this;
                    const credentials = {
                        role_id: role.value,
                        name,
                        email,
                        password,
                        sectorAssociationName: sectorAssociationName.value,
                        is_external: externalSource,
                    };
                    const isRegistered = await this.$store.dispatch('auth/register', credentials);
                    if (isRegistered) {
                        this.$router.push({ name: 'auth-login'});
                    }
                }
            },
        },

        components: {
            'base-button': BaseButton,
            'base-select': BaseSelect,
        }
    };
</script>

<style lang="scss">
    #internal-source-label {
        color: inherit;
        &::before {
            background: #7fcf1a;
        }
    }
</style>